import { Button, Menu } from "antd";
import { useAuth } from "AuthContext";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    LogoutOutlined,
    UserOutlined,
    LoginOutlined,
    ApartmentOutlined,
} from "@ant-design/icons";

function Navigation({ items }) {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <Menu
            onClick={(e) => {
                navigate(e.key);
            }}
            mode="horizontal"
            items={items}
            selectedKeys={location.pathname}
            theme="dark"
        />
    );
}

const menu = [
    { key: "exercise-session", label: "Phiếu bài tập" },
    // { key: "student", label: "Quản lý học sinh" },
    { key: "attendance", label: "Điểm danh" },
    { key: "timetable", label: "Thời khóa biểu" },
    { key: "student-evaluation", label: "Đánh giá" },
];

const loginMenu = [
    // { key: "key", label: "Label" },
];

const adminMenu = [
    // {role: 0, menu: [ { key: "key", label: "Label" } ]},
    // {role: 1, menu: [ { key: "key", label: "Label" } ]},
]

const styles = {
    container: {
        position: "relative",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center",
        justifyContentLg: "flex-start",
    },
    icon: {
        position: "absolute",
        top: "50%",
        left: 10,
        transform: "translateY(-50%)",
        color: "#fff",
        fontSize: 20,
    },
    menu: {
        backgroundColor: "transparent",
        color: "white",
        flex: 1,
        paddingLeft: 40,
    },
};

const mainMenuStyles = {
    header: {
        backgroundColor: "#000",
        color: "white",
        position: "sticky",
        top: 0,
        zIndex: 1000,
    },
    menuWrapper: {
        backgroundColor: "#275c87",
    },
    container: {
        maxWidth: 1200,
        margin: "0 auto",
        padding: "0 16px",
    },
    inner: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center",
        padding: "8px 0",
    },
    logoLink: {
        display: "flex",
        alignItems: "center",
        marginBottom: 8,
        textDecoration: "none",
        color: "white",
        marginRight: 12,
    },
    navWrapper: {
        marginBottom: 8,
        marginRight: "auto",
    },
    buttonGroup: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    button: {
        marginRight: 8,
    },
};

function AdminMenu() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    var items = [];
    for (const menus of adminMenu) {
        if (user?.role <= menus.role) {
            items = [...items, ...menus.menu];
        }
    }
    return (
        items.length > 0 && (
            <div style={{ backgroundColor: "#275c87" }}>
            <div style={styles.container}>
                <ApartmentOutlined style={styles.icon} />
                <Menu
                    items={items}
                    theme="dark"
                    selectedKeys={[location.pathname]}
                    onClick={(e) => navigate(e.key)}
                    mode="horizontal"
                    style={styles.menu}
                />
            </div>
        </div>
        )
    );
}

export default function Header() {
    const navigate = useNavigate();
    const [buttonWidth, setButtonWidth] = useState(250);
    const buttonRef = useRef(null);
    const { user, logout } = useAuth();
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setButtonWidth(entry.contentRect.width);
            }
        });
        resizeObserver.observe(buttonRef.current);
    }, []);
    const final_menu = [...menu, ...(user ? loginMenu : [])];
    return (
        <header style={mainMenuStyles.header}>
            <div style={mainMenuStyles.menuWrapper}>
                <AdminMenu />
            </div>
            <div style={mainMenuStyles.container}>
                <div style={mainMenuStyles.inner}>
                    <Link to="#" style={mainMenuStyles.logoLink}>
                        <img
                            className="hide-on-mobile"
                            alt="logo"
                            src={process.env.PUBLIC_URL + "/img/logo.png"}
                            width="40px"
                        />
                    </Link>

                    <div
                        className="header-menu"
                        style={{
                            ...mainMenuStyles.navWrapper,
                            width: `calc(100% - ${buttonWidth}px - 50px)`,
                        }}
                    >
                        <Navigation items={final_menu} />
                    </div>

                    <div style={mainMenuStyles.buttonGroup} ref={buttonRef}>
                        {user ? (
                            <>
                                <Button
                                    type="primary"
                                    style={mainMenuStyles.button}
                                    onClick={() => navigate("/account")}
                                >
                                    <UserOutlined /> {user?.first_name}
                                </Button>
                                <Button onClick={logout}>
                                    <LogoutOutlined /> Logout
                                </Button>
                            </>
                        ) : (
                            <Button
                                type="primary"
                                style={mainMenuStyles.button}
                                onClick={() => navigate("/login")}
                            >
                                <LoginOutlined /> Đăng nhập
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
}
